import $ from 'jquery';
export default class HideElementOnClick {
    static init() {
        $('.js__hide-on-click').each((i, element) => {
            const $element = $(element);
            const $target = $($element.data('target'));
            $target.on('click', () => {
                $element.addClass('d-none');
            });
        });
    }
}
